var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM26.4609 26.6484L23.8828 26.6367L20 22.0078L16.1211 26.6328L13.5391 26.6445C13.3672 26.6445 13.2266 26.5078 13.2266 26.332C13.2266 26.2578 13.2539 26.1875 13.3008 26.1289L18.3828 20.0742L13.3008 14.0234C13.2536 13.9662 13.2274 13.8945 13.2266 13.8203C13.2266 13.6484 13.3672 13.5078 13.5391 13.5078L16.1211 13.5195L20 18.1484L23.8789 13.5234L26.457 13.5117C26.6289 13.5117 26.7695 13.6484 26.7695 13.8242C26.7695 13.8984 26.7422 13.9688 26.6953 14.0273L21.6211 20.0781L26.6992 26.1328C26.7461 26.1914 26.7734 26.2617 26.7734 26.3359C26.7734 26.5078 26.6328 26.6484 26.4609 26.6484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.0caf0b5336d94fa65d70206c5064cacc.svg";
export { ForwardRef as ReactComponent };